/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VwbGroupDescription
 */
export interface VwbGroupDescription {
    /**
     * Name of the group
     * @type {string}
     * @memberof VwbGroupDescription
     */
    groupName?: string;
    /**
     * Whether this group is system-managed (data access tier groups)
     * @type {boolean}
     * @memberof VwbGroupDescription
     */
    managed?: boolean;
    /**
     * Email of the group creator
     * @type {string}
     * @memberof VwbGroupDescription
     */
    createdBy?: string;
    /**
     * Timestamp the group was created
     * @type {string}
     * @memberof VwbGroupDescription
     */
    createdDate?: string;
}

/**
 * Check if a given object implements the VwbGroupDescription interface.
 */
export function instanceOfVwbGroupDescription(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VwbGroupDescriptionFromJSON(json: any): VwbGroupDescription {
    return VwbGroupDescriptionFromJSONTyped(json, false);
}

export function VwbGroupDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbGroupDescription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'managed': !exists(json, 'managed') ? undefined : json['managed'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'createdDate': !exists(json, 'createdDate') ? undefined : json['createdDate'],
    };
}

export function VwbGroupDescriptionToJSON(value?: VwbGroupDescription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groupName': value.groupName,
        'managed': value.managed,
        'createdBy': value.createdBy,
        'createdDate': value.createdDate,
    };
}

